import { EWinningCreditType } from './kindReward.model';

export const FORM_FIELD_KEYS = {
	TOURNAMENT_ID: 'tournamentID',
	USER_ID: 'userId',
	BUYING_PRICE: 'buyingPrice',
	CREDIT_TYPE: 'creditType'
};

export const REWARD_TYPE_OPTIONS = [
	{ id: EWinningCreditType.CASH, label: EWinningCreditType.CASH },
	{ id: EWinningCreditType.KIND, label: EWinningCreditType.KIND }
];
